import { color } from "src/styles/globals";
import { down } from "styled-breakpoints";
import styled from "styled-components";
import { Title } from "sunday-component";

export const LinkTextBox = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
  border: 1px solid ${color.charcoal03};
  border-radius: 8px;
  padding: 12px;
  width: 100%;
  cursor: pointer;
  ${down("sm")} {
    width: 100%;
  }
`;

export const StyledCopyIcon = styled.img`
  width: 24px;
  height: 24px;
  cursor: pointer;
`;

export const SubTitle = styled(Title).attrs({ level: 7 })``;

export const LinkText = styled(Title).attrs({ level: 7 })`
  color: ${color.carrotOrange};
  width: calc(100% - 32px);
  word-break: break-all;
`;
